import React, { Component } from 'react';

export default class Markdown extends Component {

  constructor(props) {
    super(props)
    this.state = {
        value: 'Hello, **People**:p' };
  }

}